import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { put as putBE } from "utils/api";
import { message } from "actions/message";
import FormikField from "components/forms/formik-field";
import { Formik } from "formik";
import { Tooltip } from "components/ui/tool-tip/tooltip";
import IoIosInformationCircleOutline from "react-icons/lib/io/ios-information";

const PhysicianUpdateForm = ({ patientGuidForJobs }) => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);

  const updatePhysicianDate = async values => {
    dispatch(message("Updating Physician Appointment Date..."));
    await putBE(`IVR/Work/UpdatePhysicianAppointment`, values);
  };

  return (
    <div>
      {!showForm ? (
        <button onClick={() => setShowForm(true)}>Change Physician Appointment Form</button>
      ) : (
        <Formik
          initialValues={{
            patient_guid: patientGuidForJobs,
            physician_date:null
          }}
        >
          {({ values }) => (
            <form>
              <div
                style={{
                  display: "flex",
                  justifyItems: "center"
                }}
              >
                <Tooltip
                  id={`friendly_name`}
                  className="helpful-link-tooltip"
                  effect="solid"
                  message='Will update all patient orders with the status "IVR Pending Work".'
                >
                  <IoIosInformationCircleOutline size="1rem" />
                </Tooltip>
              

<FormikField
                                name="physician_date"
                                label="Next Physicain Appointment Date"
                                type="date"
                            />
                            </div>

              <button
                style={{ marginRight: "10px" }}
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
              <button
                disabled={
                  values.physician_date == null
                }
                onClick={() => {
                  updatePhysicianDate(values);
                }}
              >
                Submit
              </button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

PhysicianUpdateForm.propTypes = {
    patientGuidForJobs: PropTypes.string.isRequired
};

export default PhysicianUpdateForm;
